import React from 'react';
import Autosuggest from 'react-autosuggest';
import superagent from 'superagent';

import * as fuzzy from './fuzzy';

const otherSection = {
    title: 'Other',
    icon: 'search',
    items: [
        {
            name: 'Google Search Site',
            type: 'other',
            icon: 'search'
        }
    ]
};

function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestions(allSuggestions, value) {
    const escapedValue = escapeRegexCharacters(value.trim());
    if (escapedValue === '') {
        return [];
    }
    const suggestions = allSuggestions
        .map(section => {
            const items = fuzzy.filter(section.items, value, { extract: o => o.name });
            return {
                title: section.title,
                items
            };
        })
        .filter(section => section.items.length > 0);
    suggestions.push(otherSection);
    return suggestions;
}

function getSuggestionValue(suggestion) {
    return suggestion.name || suggestion.option.name;
}

function renderSectionTitle(section) {
    return <strong>{section.title}</strong>;
}

function renderSuggestion(suggestion, { value, valueBeforeUpDown }) {
    const html = suggestion.display || suggestion.name;
    return (
        <div>
            <i className="material-icons">{suggestion.icon}</i>
            <span dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    );
}

function getSectionSuggestions(section) {
    return section.items;
}

export default class NavSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            suggestions: []
        };
        this._onChange = this._onChange.bind(this);
        this._onSuggestionsUpdateRequested = this._onSuggestionsUpdateRequested.bind(this);
        this._onSuggestionSelected = this._onSuggestionSelected.bind(this);
    }

    _onChange(event, { newValue }) {
        this.setState({
            value: newValue
        });
    }

    retrieveSuggestions() {
        const apiUrl = '/api/search-suggestions';
        this.requestMade = true;
        superagent.get(apiUrl, (error, response) => {
            if (error) {
                console.log('error', error); // TODO
            }
            const result = response.body;
            const { players, oppositions } = result.data;
            players.forEach(player => {
                player.type = 'player';
                player.icon = 'person';
            });
            oppositions.forEach(opposition => {
                opposition.type = 'opposition';
                opposition.icon = 'people';
            });
            this.allSuggestions = [
                {
                    title: 'Players',
                    items: players
                },
                {
                    title: 'Opposition',
                    items: oppositions
                }
            ];
            this.setState({
                suggestions: getSuggestions(this.allSuggestions, this.value)
            });
        });
    }

    _onSuggestionsUpdateRequested({ value }) {
        this.value = value;
        if (this.allSuggestions === undefined) {
            if (this.requestMade === undefined) {
                this.retrieveSuggestions();
            }
        } else {
            this.setState({
                suggestions: getSuggestions(this.allSuggestions, value)
            });
        }
    }

    _onSuggestionSelected(event, { suggestion, suggestionValue, method }) {
        suggestion = suggestion.option || suggestion;
        switch (suggestion.type) {
            case 'player':
                window.location.href = `/players/${suggestion.pid}`;
                break;
            case 'opposition':
                window.location.href = `/fixtures?season=all&opposition=${suggestion.name}`;
                break;
        }
    }

    render() {
        const { value, suggestions } = this.state;
        const inputProps = {
            placeholder: 'Search',
            value,
            onChange: this._onChange
        };
        return (
            <li>
                <div className="cc-navbar-item cc-nav-search">
                    <Autosuggest
                        multiSection
                        suggestions={suggestions}
                        onSuggestionsUpdateRequested={this._onSuggestionsUpdateRequested}
                        onSuggestionSelected={this._onSuggestionSelected}
                        getSuggestionValue={getSuggestionValue}
                        renderSuggestion={renderSuggestion}
                        renderSectionTitle={renderSectionTitle}
                        getSectionSuggestions={getSectionSuggestions}
                        inputProps={inputProps}
                    />
                    <i className="material-icons">search</i>
                </div>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavSearch.jsx